import { NotificationSettingsDialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { getNotificationPreferences, updateNotificationPreferences } from 'api/notificationAPI';
import { RTANotificationTypes } from 'components/notifications/NotificationComponentMap';
import { handleError } from 'services/Error';

const notificationTypes = [
    {
        value: RTANotificationTypes.PENDREAUTH,
        text: 'A referral is pending reauth.',
    },
];

const mapPreferencesFromApi = (preferences) => ({
    email: preferences.email,
    inApp: preferences.in_app,
});

export const UserNotificationSettingsDialog = ({ isOpen, onSecondaryButtonClick }) => {
    const [preferences, setPreferences] = useState();
    useEffect(() => {
        void (async () => {
            if (isOpen) {
                try {
                    setPreferences(mapPreferencesFromApi(await getNotificationPreferences()));
                } catch (err) {
                    onSecondaryButtonClick();
                    handleError('An error occurred retrieving notification settings.', err);
                }
            }
        })();
    }, [isOpen, onSecondaryButtonClick]);

    const onSubmit = async (values) => {
        try {
            await updateNotificationPreferences({
                email: values.email,
                in_app: values.inApp,
                sms: [], // SMS currently disabled
            });
            SuccessToast({ message: 'Your notification settings were updated successfully.' });
            onSecondaryButtonClick();
        } catch (err) {
            handleError('An error occurred updating notification settings.', err);
        }
    };

    return (
        <NotificationSettingsDialog
            isOpen={isOpen}
            notificationTypes={notificationTypes}
            values={preferences}
            onSecondaryButtonClick={onSecondaryButtonClick}
            onSubmit={onSubmit}
        />
    );
};

UserNotificationSettingsDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onSecondaryButtonClick: PropTypes.func.isRequired,
};
